import React,{ useRef, useState, useEffect } from "react"
import {useNavigate} from 'react-router-dom'
import styles from './HeaderDropdown.module.css'
import Dropdown from 'react-bootstrap/Dropdown';
import { useMyContext } from "../../myContext";
import user from '../../public/assets/user.png'


const ProfileDropdown = (props) => {

    let history = useNavigate()

    const { firstName, lastName } = props

    const [ show, setShow] = useState(false)


    const profileRef = useRef()

    useOnClickOutside(profileRef,() => setShow(false))

    // const onClickLogout = () => {
    //     sessionStorage.clear()
    //     localStorage.clear()   
    //     logout()
    //     history("/login");     
    // }


    return (
        <Dropdown className={styles.headerDropdown} show={show} ref={profileRef} alignRight>
            <Dropdown.Toggle id="dropdown-basic" className={styles.dropdownButton} onClick={() => { setShow(!show)}}>
                <div className={styles.profileName}>
                    <img src={user} style={{width: "50%"}}/>
                    {/* {firstName && lastName ? `${firstName[0].toUpperCase()}${lastName[0].toUpperCase()}` : '--'} */}
                </div>
                {/* <img src={show ? navbarArrowUp : navbarArrowDown} alt='arrow-down'/> */}
            </Dropdown.Toggle>

            <Dropdown.Menu className={styles.dropdownMenu}>
                {/* <Dropdown.Divider/> */}
                    <Dropdown.Item onClick={props.onClickLogout}>
                        <div className={styles.dropdownRow} style={{paddingLeft:"13.5px"}}>
                            {/* <img src={logoutIcon} alt='icon' style={{marginRight:"9.5px"}} width="15px"/> */}
                            <p className={styles.textRed}>Logout</p>
                        </div>
                    </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    )
}


function useOnClickOutside(ref, handler) {
    useEffect(
      () => {
        const listener = (event) => {
          if (!ref.current || ref.current.contains(event.target)) {
            return
          }
          handler(event)
        }
        document.addEventListener('mousedown', listener)
        document.addEventListener('touchstart', listener)
        return () => {
          document.removeEventListener('mousedown', listener)
          document.removeEventListener('touchstart', listener)
        }
      },
      [ref, handler]
    )
}


export default ProfileDropdown